import React, { useCallback } from 'react'
import './index.scss'
import { Link } from 'react-router'
import clsx from 'clsx'
import { WorkModel } from '@Entities/work/work'
import WorkItemPillSection from '@Components/WorkItemPillSection'
import { ClickableItemCard } from '@Components/Cards/ClickableItemCard'
import { WriterModel } from '@Entities/work/writer-model'
import { formatName } from '@App/helpers/format-name'
import CheckBox from '@Components/Selectors/Checkbox'
import { observer } from 'mobx-react'

interface CompactWorkData {
    work: WorkModel
    catalogPath: string
    children?: React.ReactNode[] | React.ReactNode
    className?: string
    handleOnClick?: (work: WorkModel) => void
    isBulkActionStarted?: boolean
    isBulkActionDisabled?: boolean
    bulkActionDisabledMessage?: string
    bulkActionToggle?(): void
    isBulkActionSelected?(): boolean
}

const CompactWorkItem = (props: CompactWorkData) => {
    const {
        work,
        catalogPath,
        children,
        className,
        isBulkActionStarted,
        isBulkActionDisabled,
        bulkActionToggle,
        isBulkActionSelected,
        bulkActionDisabledMessage,
    } = props

    const handleOnClick = useCallback(() => {
        if (work && props.handleOnClick) {
            props.handleOnClick(work)
        }
    }, [])

    return (
        <ClickableItemCard
            className={clsx(
                'compact-work-item',
                className,
                isBulkActionDisabled && isBulkActionStarted && 'bulk-action-disabled'
            )}
            path={isBulkActionStarted ? undefined : catalogPath}
            handleOnClick={isBulkActionStarted ? undefined : handleOnClick}
        >
            <div className={clsx('container work-title', isBulkActionStarted && 'bulk-action-editing')}>
                {isBulkActionStarted && bulkActionToggle && isBulkActionSelected && (
                    <CheckBox
                        key={work.id}
                        id={work.id?.toString() || ''}
                        onClick={() => bulkActionToggle()}
                        checked={isBulkActionSelected()}
                        mainColor
                        disabled={isBulkActionDisabled}
                        checkboxMessage={bulkActionDisabledMessage}
                    />
                )}
                {catalogPath && !isBulkActionStarted ? (
                    <Link
                        to={catalogPath}
                        className="title-link"
                        onClick={(e) => {
                            e.stopPropagation()
                            props.handleOnClick && props.handleOnClick(work)
                        }}
                        onMouseDown={(e) => {
                            e.stopPropagation()
                        }}
                    >
                        {work.title}
                    </Link>
                ) : (
                    work.title
                )}
                <WorkItemPillSection work={work} />
            </div>

            {work.songCode && <div className="container song-code">{work.songCode}</div>}
            <div className="container writers">
                {work.writers
                    .map((writer: WriterModel) =>
                        writer ? formatName(writer.firstName, writer.lastName, writer.fullName) : 'Unknown Writer'
                    )
                    .filter(Boolean)
                    .join(', ')}
            </div>
            {children}
        </ClickableItemCard>
    )
}

export default observer(CompactWorkItem)
